import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import MaintenanceCommand from './maintenanceCommand/maintenanceCommand.js';
import './maintenanceMonitor.css';

const MaintenanceMonitor = (props) => {

  const {
    allCommands,
    maintenanceData,
    updateMaintenanceData
  } = props;

  // Update the maintenance data when the component is mounted.
  useEffect(() => {
    updateMaintenanceData();
  }, []);

  let maintenanceArray = [];

  if (maintenanceData.sequence) maintenanceArray = Object.entries(maintenanceData.sequence);

  /*
    The maintenance monitor works by downloading the estimated maintenance schedule and matching the
    comments from that against the comments in currently running commands.
  */

  return (
    <div className="MaintenanceMonitorPage">
      <div className="MaintenanceOrder">
        {maintenanceArray.map(command => {
          const foundCommand = allCommands.find(curCommand => curCommand.Comment === command[0]);
          const foundCommands = allCommands.filter(curCommand => curCommand.Comment === command[0]);
          return foundCommand && <MaintenanceCommand key={command[0]} command={command} curCommand={foundCommand} curCommands={foundCommands}/>;
        })}
      </div>
      <div className="MaintenanceInfo">
        {allCommands.sort((a, b) => [a.RequestedDateTime, b.RequestedDateTime].sort()[0] === a.RequestedDateTime ? 1 : -1).map(command => {
          return (
            <div className={`MaintenanceRecentCommand MaintenanceRecentCommand-${command.Status}`} key={command.CommandId}>
              <p>{command.Status} - {command.RequestedDateTime} - {command.CommandId}</p>
              <p>{command.DocumentName} - {command.Comment}</p>
              <p>"{command.Parameters.commands ? command.Parameters.commands.join(' - ') : '*No commands found*'}"</p>
            </div>
          );
        })}
      </div>
    </div>
  );

};

MaintenanceMonitor.propTypes = {
  allCommands: PropTypes.array,
  maintenanceData: PropTypes.object,
  updateMaintenanceData: PropTypes.func
};

export default MaintenanceMonitor;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/maintenanceMonitor/maintenanceMonitor.js